import { render, staticRenderFns } from "./choosePositionDialog.vue?vue&type=template&id=53205236"
import script from "./choosePositionDialog.vue?vue&type=script&lang=js"
export * from "./choosePositionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports